import { resourceConstants } from "../actions/constants/resourceConstant";

const resourceData = (state = { status: "", message: "" }, action: any) => {
	switch (action.type) {
		// History (inactive) resources table
		case resourceConstants.Resource_GetByFilter_Request:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isListSuccess: false,
			};
		case resourceConstants.Resource_GetByFilter_Success:
			return {
				...state,
				isLoading: false,
				isError: false,
				isSuccess: true,
				isListSuccess: true,
				historyItems: action.payload,
			};
		case resourceConstants.Resource_GetByFilter_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: false,
				status: action.payload,
			};

		// Active resources table - own flags so it can load alongside the history table
		case resourceConstants.Resource_GetActive_Request:
			return {
				...state,
				isActiveLoading: true,
				isActiveError: false,
				isActiveListSuccess: false,
			};
		case resourceConstants.Resource_GetActive_Success:
			return {
				...state,
				isActiveLoading: false,
				isActiveError: false,
				isActiveListSuccess: true,
				activeItems: action.payload,
			};
		case resourceConstants.Resource_GetActive_Failure:
			return {
				...state,
				isActiveLoading: false,
				isActiveError: true,
				isActiveListSuccess: false,
				status: action.payload,
			};

		case resourceConstants.ResourceSaveRequest:
			return {
				...state,
				isLoading: true,
				isFormSubmit: true,
				isError: false,
				isSuccess: false,
				resourceInput: action.input?.resourceInput,
			};
		case resourceConstants.ResourceSaveSuccess:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isError: false,
				isSuccess: true,
				status: action.payload.status,
			};
		case resourceConstants.ResourceSaveFailure:
			return {
				...state,
				isLoading: false,
				isFormSubmit: false,
				isSuccess: false,
				isError: true,
				status: action.payload,
			};

		case resourceConstants.ResourceDetailRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDetailComplete: false,
			};
		case resourceConstants.ResourceDetailSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDetailError: false,
				isDetailComplete: true,
				resourceInput: action.payload,
			};
		case resourceConstants.ResourceDetailFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDetailError: true,
				isDetailComplete: true,
				status: action.payload,
			};

		case resourceConstants.ResourceDeleteRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isDeleteCompleted: false,
			};
		case resourceConstants.ResourceDeleteSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isDeleteCompleted: true,
				status: action.payload?.status,
			};
		case resourceConstants.ResourceDeleteFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isDeleteCompleted: true,
				status: action.payload,
			};

		// Status toggle from the active list
		case resourceConstants.ResourceStatusUpdateRequest:
			return {
				...state,
				isStatusUpdating: true,
				isStatusUpdated: false,
				isStatusError: false,
			};
		case resourceConstants.ResourceStatusUpdateSuccess:
			return {
				...state,
				isStatusUpdating: false,
				isStatusUpdated: true,
				isStatusError: false,
				status: action.payload?.status,
			};
		case resourceConstants.ResourceStatusUpdateFailure:
			return {
				...state,
				isStatusUpdating: false,
				isStatusUpdated: true,
				isStatusError: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default resourceData;
